import React from 'react';
import { Download, FileText } from 'lucide-react';
import { Button } from './ui/button';

const FestivalCatalogue = () => {
  return (
    <section className="relative bg-black text-white py-16 sm:py-24 md:py-32">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="max-w-5xl mx-auto">
          {/* Festival Catalogue Section */}
          <div className="bg-gradient-to-br from-zinc-900 to-black border border-white/10 rounded-xl sm:rounded-2xl p-6 sm:p-8 md:p-12 relative overflow-hidden">
            {/* Decorative Elements */}
            <div className="absolute top-0 right-0 w-48 sm:w-64 h-48 sm:h-64 bg-red-500/5 rounded-full blur-3xl"></div>
            <div className="absolute bottom-0 left-0 w-48 sm:w-64 h-48 sm:h-64 bg-red-500/5 rounded-full blur-3xl"></div>
            
            <div className="relative z-10 grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 items-center">
              {/* Left Side - Icon/Illustration */}
              <div className="flex justify-center md:justify-start">
                <div className="w-40 sm:w-48 h-40 sm:h-48 bg-red-500/10 rounded-xl sm:rounded-2xl flex items-center justify-center border border-red-500/20">
                  <FileText size={60} className="text-red-500 sm:w-20 sm:h-20" />
                </div>
              </div>

              {/* Right Side - Content */}
              <div>
                <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-3 sm:mb-4">
                  FESTIVAL CATALOGUE
                </h3>
                <p className="text-sm sm:text-base text-gray-400 mb-2">
                  <span className="text-red-500 font-semibold">2nd Edition • 2026</span>
                </p>
                <p className="text-sm sm:text-base text-gray-300 mb-4 sm:mb-6 leading-relaxed">
                  Explore our complete festival programme featuring film synopses, director profiles, screening schedules, and special events from the 2026 edition.
                </p>
                <a
                  href="https://drive.google.com/file/d/1Z48nhFf39ajAgAa6SylMcnP2iGv_Auuk/view?usp=share_link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Button 
                    size="lg"
                    className="bg-red-500 text-white hover:bg-red-600 transition-all duration-300 group text-xs sm:text-sm md:text-base px-4 sm:px-6 md:px-8 py-2 sm:py-3 md:py-4"
                  >
                    <Download size={16} className="mr-2 sm:size-5 group-hover:animate-bounce" />
                    Download Catalogue
                  </Button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5 pointer-events-none">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>
    </section>
  );
};

export default FestivalCatalogue;
